import * as React from "react";

const ArrowLeft = (props) => (
  <svg width={9} height={16} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M8 1 1 8l7 7"
      stroke="#474747"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ArrowLeft;
